<div
  class="placeholder-root"
  fxFlex="100"
  style="width: 100%"
  [@animate]="{ value: '*', params: { y: '100%' } }"
>
  <div
    class="course-content placeholder-background"
    fxLayout="column"
    fxFlex="1 1 auto"
  >
    <div class="header" fxLayout="row" fxLayoutAlign="center center"></div>

    <div class="footer" fxLayout="row" fxLayoutAlign="center center"></div>
  </div>
</div>
